<!--
  El editable NO se llena por interpolación: sus nodos los construye el componente (texto, <br> y
  figuras). Así no hay `innerHTML` con contenido de usuario ni forma de meter HTML ajeno.
-->
<div class="wl-ed" [class.is-disabled]="disabled">
  <div #box
    class="wl-ed-box"
    [attr.contenteditable]="disabled ? 'false' : 'true'"
    [style.minHeight.em]="minRows * 1.5"
    role="textbox"
    aria-multiline="true"
    [attr.aria-label]="placeholder"
    (input)="onInput()"
    (blur)="onBlur()"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
    (drop)="onDrop($event)"
    (click)="onClick($event)"></div>

  <!-- El placeholder va aparte y no como :empty::before: un editable "vacío" casi nunca lo está
       (el navegador le deja un <br> dentro), así que ese selector no dispara. -->
  <span class="wl-ed-placeholder" *ngIf="empty && placeholder">{{ placeholder }}</span>
</div>
